export default {
  login: {
    title: 'Login',
    tab: 'Log in',
    tipMessage: {
      part1: 'Please ',
      part2: 'register ',
      part3: '(or login) and ',
      part4: 'share ',
      part5: 'your preferences to receive automated ',
      part6: 'job alerts ',
      part7: 'and career news!'
    },
    btn: {
      findPassword: 'Forgot Password'
    },
    label: {
      name: 'Email/Mobile',
      password: 'Password'
    },
    message: {
      wrongNameOrPassword: 'Your username or password is incorrect'
    }
  },
  register: {
    employee: {
      title: 'Employee Register',
      tab: 'Employee Register',
      tipMessage: {
        part1: 'A verification email will be sent to this email address shortly.',
        part2: 'Click the link in email to activate your account.'
      },
      policy: {
        body: 'I agree with the ',
        link: 'Ajinga User Terms '
      },
      label: {
        company: 'Company',
        name: 'Name',
        email: 'Email',
        employeeId: 'Employee ID',
        password: 'Create Password',
        pinCode: 'Validation Info',
        authInfo: 'Company Pin'
      },
      placeholder: {
        company: 'please choose your company',
        name: 'please input your name',
        email: 'please input your email',
        employeeId: 'please input your employee ID',
        password: 'please input your password',
        pinCode: 'please input your validation info',
        authInfo: 'please input your company pin'
      },
      message: {
        invalidEmployeeId: 'The employee ID is invalid',
        employeeIdNotMatchedEmail: 'The employee ID does not match the email',
        nameNotMatchedEmail: 'The name does not match the email',
        employeeIdHasBeenUsed: 'The employee ID has been used',
        emailHasBeenUsed: 'The email has been used',
        invalidPinCode: 'The company pin is invalid'
      }
    },
    candidate: {
      title: 'Register',
      tab: 'Register',
      btn: {
        sendSmsValidateCode: 'Get Code Now',
        tryAgainAfterTime: 'Get Code Now({count})'
      },
      label: {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Mobile/Tel',
        password: 'Create Password'
      },
      placeholder: {
        phone: 'Please input your phone number',
        validateCode: 'SMS Code',
        countryCode: 'Code'
      },
      policy: {
        body: 'I certify that I have read and agree to the ',
        link1: 'Ajinga USER Agreement ',
        link2: 'Ajinga Privacy Policy'
      },
      message: {
        emailHasBeenUsed: 'A user is already registered with this email address',
        invalidSmsValidateCode: 'Incorrect mobile phone number or SMS code'
      }
    }
  },
  findPassword: {
    email: {
      label: {
        email: 'Email',
        captcha: 'Captcha'
      },
      message: {
        captchaGeneratesFaild: 'The validation code generates failed, please contact Ajinga.',
        captchaInvalidOrExpired: 'Captcha is invalid or expired, please refresh the captcha!',
        emailNoRegister: 'This email has not been registered.',
        sendEmailSuccess: 'We sent you an email. Please check your inbox for a message.'
      }
    }
  }
}
